export default __webpack_public_path__ + "static/media/019-clapperboard.e61fb684.svg";